<template>
  <div id="ChangePwd">
    <div class="pt-1">
      <div class="m-2">
        <van-cell-group class="text-left">
          <van-field
            v-model="oldPassword"
            label="原密码"
            type="password"
            placeholder="原密码"
          />

          <van-field
            v-model="newPwd"
            label="新密码"
            type="password"
            placeholder="新密码"
          />

          <van-field
            v-model="repeatPwd"
            type="password"
            label="重复密码"
            placeholder="重复密码"
          />
        </van-cell-group>

        <el-alert type="warning" style="line-height: normal" :closable="false">
          新密码至少设置八位,需包含至少一个大写字符一个小写字母、数字，不可是连续的数字、字母（如：abcd、1234、zaq1、1111、2222、aaaa、bbbb等）
        </el-alert>
        <van-button plain hairline type="info mt-4 w-100" @click="setPwdBtn"
          >修改密码</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangePwd",
  data () {
    return {
      oldPassword: "",
      newPwd: "",
      repeatPwd: ""
    };
  },
  methods: {

    setPwdBtn: function () {
      // eslint-disable-next-line no-console
      console.log(this.newPwd, this.repeatPwd);
      if (this.oldPassword == "") {
        this.$toast("原密码不能为空");
        return;
      }
      if (this.newPwd && this.repeatPwd) {
        if (this.newPwd == this.repeatPwd) {

          var num1 = '';
          var num2 = '';
          if (this.oldPassword.length < 10)
            num1 = "0" + this.oldPassword.length
          else
            num1 = this.oldPassword.length

          if (this.newPwd.length < 10)
            num2 = "0" + this.newPwd.length
          else
            num2 = this.newPwd.length

          var json = {
            OldPassword: this.encrypt(num1 + this.oldPassword),
            NewPassword: this.encrypt(num2 + this.newPwd)
          };
          this.apiUserPut(json, this, e => {
            this.$toast(e.message);
            if (e.code == 20000) {
              this.oldPassword = null;
              this.newPwd = null;
              this.repeatPwd = null;
              this.$router.push("/Login");
            }
          });
        } else {
          this.$toast("两次输入的密码不相同");
        }
      } else {
        this.$toast("请输入密码");
      }
    }
  }
};
</script>

<style scoped>
#ChangePwd {
  background: #efefef;
  min-height: 700px;
}
</style>
